export default {
  updateUserType (state, payload) {
    state.userType = payload;
  },

}